import header from './header.json';

const jp = {
  ...header,
};

export { jp };
